/* eslint-disable no-useless-escape, max-len */
import { matchPath } from 'react-router';

export const getBoatsConstants = (routesConstants = {}) => {
  let config = routesConstants;

  // NOTE: This list is not in a full RegExp pattern as it might need to start with ^ in some cases.
  // NOTE: This one is very important, as ALLOWED_CHARACTERS_IN_URL is also used to removed undesired characters,
  //       an % or a $ symbol needs to be manually added where encoded params are tested.
  const ALLOWED_CHARACTERS_IN_URL = 'a-zA-Zа-яА-ЯΆΈ-ϗἀ-῾ÂÇÎÓÖÛÜâåçîóöûüÄäĄąĆćčđĘęĞğİıŁłŃńŚśŞşšŹźŻżž0-9&\-.,\'æäé';
  const ALLOWED_CHARACTERS_IN_BLOG_CATEGORY_URL = 'a-zA-Z0-9 ';
  const KEYWORD_SEARCH_PATTERN = `[ -.|0-~|\xa1-\xff|${ALLOWED_CHARACTERS_IN_URL}]`;
  const LISTING_SAME_DEALER = 'same seller listing';
  const LISTING_MULTI_CONTACT = 'multi contact listing';
  const LISTING_ENHANCED = 'enhanced listing';
  const LISTING_SPONSORED = 'sponsored listing';
  const LISTING_PREMIUM_BROKER = 'premium broker banner';
  const LISTING_MANUFACTURER = 'manufacturer listing';
  const LISTING_SUGGESTED = 'suggested listing';
  const LISTING_OEM_BRAND = 'oem brand listing';
  const LISTING_STANDARD = 'standard listing';
  const DEFAULT_NO_BOAT_IMAGE = '//assets.boattrader.com/img/default/thumbnail.gif';
  const _searchParamsPatterns = [
    `:condition(${config.SEARCH_URL_ITEM_CONDITION}\-[^/]+)?/`,
    `:types(${config.SEARCH_URL_ITEM_TYPES}-[${ALLOWED_CHARACTERS_IN_URL}|+|%]+)?/`,
    `:classes(${config.SEARCH_URL_ITEM_CLASS}\-[${ALLOWED_CHARACTERS_IN_URL}|+|%]+)?/`,
    `:make(${config.SEARCH_URL_ITEM_MAKE}\-[^/]+)?/`,
    `:modelRange(${config.SEARCH_URL_ITEM_MODELRANGE}\-[^/]+)?/`,
    `:model(${config.SEARCH_URL_ITEM_MODEL}\-[^/]+)?/`,
    `:country(${config.SEARCH_URL_ITEM_COUNTRY}\-[${ALLOWED_CHARACTERS_IN_URL}%$]+)?/`,
    `:region(${config.SEARCH_URL_ITEM_REGION}\-[a-z|0-9|+|%|,|-]+)?/`,
    `:subdivision(${config.SEARCH_URL_ITEM_SUBDIVISION}\-[${ALLOWED_CHARACTERS_IN_URL}%$]+)?/`,
    `:city(${config.SEARCH_URL_ITEM_CITY}\-[^/]+)?/`,
    `:postalCode(${config.SEARCH_URL_ITEM_POSTALCODE}\-[0-9]+)?/`,
    `:by(${config.SEARCH_URL_ITEM_BY}\-[a-z|0-9|%-]+)?/`,
    `:radius(${config.SEARCH_URL_ITEM_RADIUS}\-[0-9|${config.SEARCH_URL_ITEM_RADIUS_EXACT}|${config.SEARCH_URL_ITEM_RADIUS_ANY}]+)?/`,
    `:makeModel(${config.SEARCH_URL_ITEM_MAKEMODEL}\-[^/]+)?/`,
    `:engine(${config.SEARCH_URL_ITEM_ENGINE}\-[a-z|0-9|%| ,\+,\-]+)?/`,
    `:length(${config.SEARCH_URL_ITEM_LENGTH}\-[0-9|,]+)?/`,
    `:price(${config.SEARCH_URL_ITEM_PRICE}\-[0-9|,]+)?/`,
    `:year(${config.SEARCH_URL_ITEM_YEAR}\-[0-9|,]+)?/`,
    `:fuelType(${config.SEARCH_URL_ITEM_FUEL}\-[${ALLOWED_CHARACTERS_IN_URL}|+|%]+)?/`,
    `:hullMaterial(${config.SEARCH_URL_ITEM_HULL}\-[${ALLOWED_CHARACTERS_IN_URL}|+|%]+)?/`,
    `:page(${config.SEARCH_URL_ITEM_PAGE}\-[0-9]+)?/`,
    `:sort(${config.SEARCH_URL_ITEM_SORT}\-[^/]+:[^/]+)?/`,
    `:keyword(%?3?F?${config.SEARCH_URL_ITEM_KEYWORD}[\-|\=]${KEYWORD_SEARCH_PATTERN}+)?/`,
    ':modal(modal-[a-z|+]+)?/',
  ];

  const _generateSearchParamsPatterns = [
    `:condition(${encodeURIComponent(config.SEARCH_URL_ITEM_CONDITION)}\-[a-z|0-9|+|%|,|-]+)?/`,
    `:types(${encodeURIComponent(config.SEARCH_URL_ITEM_TYPES)}-[${ALLOWED_CHARACTERS_IN_URL}|+|%]+)?/`,
    `:classes(${encodeURIComponent(config.SEARCH_URL_ITEM_CLASS)}\-[${ALLOWED_CHARACTERS_IN_URL}|+|%]+)?/`,
    `:make(${encodeURIComponent(config.SEARCH_URL_ITEM_MAKE)}\-[^/]+)?/`,
    `:modelRange(${encodeURIComponent(config.SEARCH_URL_ITEM_MODELRANGE)}\-[^/]+)?/`,
    `:model(${encodeURIComponent(config.SEARCH_URL_ITEM_MODEL)}\-[^/]+)?/`,
    `:country(${encodeURIComponent(config.SEARCH_URL_ITEM_COUNTRY)}\-[${ALLOWED_CHARACTERS_IN_URL}%$]+)?/`,
    `:region(${encodeURIComponent(config.SEARCH_URL_ITEM_REGION)}\-[a-z|0-9|+|%|,|-]+)?/`,
    `:subdivision(${encodeURIComponent(config.SEARCH_URL_ITEM_SUBDIVISION)}\-[${ALLOWED_CHARACTERS_IN_URL}%$]+)?/`,
    `:city(${encodeURIComponent(config.SEARCH_URL_ITEM_CITY)}\-[^/]+)?/`,
    `:postalCode(${encodeURIComponent(config.SEARCH_URL_ITEM_POSTALCODE)}\-[0-9]+)?/`,
    `:by(${encodeURIComponent(config.SEARCH_URL_ITEM_BY)}\-[a-z|0-9|%-]+)?/`,
    `:radius(${encodeURIComponent(config.SEARCH_URL_ITEM_RADIUS)}\-[0-9|${config.SEARCH_URL_ITEM_RADIUS_EXACT}|${config.SEARCH_URL_ITEM_RADIUS_ANY}]+)?/`,
    `:makeModel(${encodeURIComponent(config.SEARCH_URL_ITEM_MAKEMODEL)}\-[^/]+)?/`,
    `:engine(${encodeURIComponent(config.SEARCH_URL_ITEM_ENGINE)}\-[a-z|0-9|%| ,\+,\-]+)?/`,
    `:length(${encodeURIComponent(config.SEARCH_URL_ITEM_LENGTH)}\-[0-9|,]+)?/`,
    `:price(${encodeURIComponent(config.SEARCH_URL_ITEM_PRICE)}\-[0-9|,]+)?/`,
    `:year(${encodeURIComponent(config.SEARCH_URL_ITEM_YEAR)}\-[0-9|,]+)?/`,
    `:fuelType(${encodeURIComponent(config.SEARCH_URL_ITEM_FUEL)}\-[${ALLOWED_CHARACTERS_IN_URL}|+|%]+)?/`,
    `:hullMaterial(${encodeURIComponent(config.SEARCH_URL_ITEM_HULL)}\-[${ALLOWED_CHARACTERS_IN_URL}|+|%]+)?/`,
    `:page(${encodeURIComponent(config.SEARCH_URL_ITEM_PAGE)}\-[0-9]+)?/`,
    `:sort(${encodeURIComponent(config.SEARCH_URL_ITEM_SORT)}\-[^/]+:[^/]+)?/`,
    `:keyword(%?3?F?${encodeURIComponent(config.SEARCH_URL_ITEM_KEYWORD)}[\-|\=]${KEYWORD_SEARCH_PATTERN}+)?/`,
    ':modal(modal-[a-z|+]+)?/',
  ];

  const _engineSearchParamsPatterns = [
    `:condition(${config.SEARCH_URL_ITEM_CONDITION}\-[^/]+)?/`,
    `:category(${config.SEARCH_URL_ITEM_CATEGORY}-[^/:]+)?/`,
    `:types(${config.SEARCH_URL_ITEM_TYPES}-[a-z|0-9|+|%|,|-]+)?/`,
    `:fuel(${config.SEARCH_URL_ITEM_FUEL}\-[^/]+)?/`,
    `:make(${config.SEARCH_URL_ITEM_MAKE}\-[^/]+)?/`,
    `:model(${config.SEARCH_URL_ITEM_MODEL}\-[^/]+)?/`,
    `:country(${config.SEARCH_URL_ITEM_COUNTRY}\-[${ALLOWED_CHARACTERS_IN_URL}%$]+)?/`,
    `:region(${config.SEARCH_URL_ITEM_REGION}\-[a-z|0-9|+|%|,|-]+)?/`,
    `:subdivision(${config.SEARCH_URL_ITEM_SUBDIVISION}\-[${ALLOWED_CHARACTERS_IN_URL}%$]+)?/`,
    `:city(${config.SEARCH_URL_ITEM_CITY}\-[^/]+)?/`,
    `:classes(${config.SEARCH_URL_ITEM_CLASS}-[a-z0-9\+%, \-]+)?/`,
    `:powerhp(${config.SEARCH_URL_ITEM_POWER_HP}\-[0-9|,]+)?/`,
    `:by(${config.SEARCH_URL_ITEM_BY}\-[a-z|0-9|%-]+)?/`,
    `:makeModel(${config.SEARCH_URL_ITEM_MAKEMODEL}\-[^/]+)?/`,
    `:price(${config.SEARCH_URL_ITEM_PRICE}\-[0-9|,]+)?/`,
    `:year(${config.SEARCH_URL_ITEM_YEAR}\-[0-9|,]+)?/`,
    `:page(${config.SEARCH_URL_ITEM_PAGE}\-[0-9]+)?/`,
    `:sort(${config.SEARCH_URL_ITEM_SORT}\-[^/]+:[^/]+)?/`,
    `:keyword(%?3?F?${config.SEARCH_URL_ITEM_KEYWORD}[\-|\=]${KEYWORD_SEARCH_PATTERN}+)?/`,
    ':modal(modal-[a-z|+]+)?/',
  ];

  const _generateEngineSearchParamsPatterns = [
    `:condition(${encodeURIComponent(config.SEARCH_URL_ITEM_CONDITION)}\-[a-z|0-9|+|%|,|-]+)?/`,
    `:category(${encodeURIComponent(config.SEARCH_URL_ITEM_CATEGORY)}-[^/:]+)?/`,
    `:types(${encodeURIComponent(config.SEARCH_URL_ITEM_TYPES)}-[a-z|0-9|+|%|,|-]+)?/`,
    `:fuel(${encodeURIComponent(config.SEARCH_URL_ITEM_FUEL)}\-[^/]+)?/`,
    `:make(${encodeURIComponent(config.SEARCH_URL_ITEM_MAKE)}\-[^/]+)?/`,
    `:model(${encodeURIComponent(config.SEARCH_URL_ITEM_MODEL)}\-[^/]+)?/`,
    `:country(${encodeURIComponent(config.SEARCH_URL_ITEM_COUNTRY)}\-[${ALLOWED_CHARACTERS_IN_URL}%$]+)?/`,
    `:region(${encodeURIComponent(config.SEARCH_URL_ITEM_REGION)}\-[a-z|0-9|+|%|,|-]+)?/`,
    `:subdivision(${encodeURIComponent(config.SEARCH_URL_ITEM_SUBDIVISION)}\-[${ALLOWED_CHARACTERS_IN_URL}%$]+)?/`,
    `:city(${encodeURIComponent(config.SEARCH_URL_ITEM_CITY)}\-[^/]+)?/`,
    `:classes(${encodeURIComponent(config.SEARCH_URL_ITEM_CLASS)}-[a-z0-9\+%, \-]+)?/`,
    `:powerhp(${encodeURIComponent(config.SEARCH_URL_ITEM_POWER_HP)}\-[0-9|,]+)?/`,
    `:by(${encodeURIComponent(config.SEARCH_URL_ITEM_BY)}\-[a-z|0-9|%-]+)?/`,
    `:makeModel(${encodeURIComponent(config.SEARCH_URL_ITEM_MAKEMODEL)}\-[^/]+)?/`,
    `:price(${encodeURIComponent(config.SEARCH_URL_ITEM_PRICE)}\-[0-9|,]+)?/`,
    `:year(${encodeURIComponent(config.SEARCH_URL_ITEM_YEAR)}\-[0-9|,]+)?/`,
    `:page(${encodeURIComponent(config.SEARCH_URL_ITEM_PAGE)}\-[0-9]+)?/`,
    `:sort(${encodeURIComponent(config.SEARCH_URL_ITEM_SORT)}\-[^/]+:[^/]+)?/`,
    `:keyword(%?3?F?${encodeURIComponent(config.SEARCH_URL_ITEM_KEYWORD)}[\-|\=]${KEYWORD_SEARCH_PATTERN}+)?/`,
    ':modal(modal-[a-z|+]+)?/',
  ];

  const SEARCH_URL_PATTERN = [
    `${config.SEARCH_URL_ROOT}`,
    ..._searchParamsPatterns,
  ].join('');

  const GENERATE_SEARCH_URL_PATTERN = [
    `${config.SEARCH_URL_ROOT}`,
    ..._generateSearchParamsPatterns,
  ].join('');

  const ENGINES_SEARCH_URL_PATTERN = [
    `${config.ENGINES_SEARCH_URL_ROOT}`,
    ..._engineSearchParamsPatterns,
  ].join('');

  const GENERATE_ENGINES_SEARCH_URL_PATTERN = [
    `${config.ENCODED_ENGINES_SEARCH_URL_ROOT}`,
    ..._generateEngineSearchParamsPatterns,
  ].join('');

  const BRANDED_SEARCH_URL_PATTERN = [
    `${config.BRANDED_SEARCH_URL_ROOT}`,
    ':owner([^/]+)/',
    ..._searchParamsPatterns,
  ].join('');

  const GENERATE_BRANDED_SEARCH_URL_PATTERN = [
    `${config.BRANDED_SEARCH_URL_ROOT}`,
    ':owner([^/]+)/',
    ..._generateSearchParamsPatterns,
  ].join('');

  const ENGINES_BRANDED_SEARCH_URL_PATTERN = [
    `${config.ENGINES_BRANDED_SEARCH_URL_ROOT}`,
    ':owner([^/]+)/',
    ..._engineSearchParamsPatterns,
  ].join('');

  const GENERATE_ENGINES_BRANDED_SEARCH_URL_PATTERN = [
    `${config.ENGINES_BRANDED_SEARCH_URL_ROOT}`,
    ':owner([^/]+)/',
    ..._generateEngineSearchParamsPatterns,
  ].join('');

  const BLOG_URL_PATTERN = [
    `${config.BLOG_URL_ROOT}`,
    `:category(${config.BLOG_URL_ENCODED_CATEGORIES})?/`,
    `:page(${config.BLOG_URL_ITEM_PAGE}\-[0-9]+)?/`,
    `:article([${ALLOWED_CHARACTERS_IN_URL}_$%]+)?/`,
  ].join('');

  const SEARCH_URL_CATEGORY_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_CATEGORY}\-([^/:]+)`
  );

  const SEARCH_URL_TYPE_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_TYPES}\-([${ALLOWED_CHARACTERS_IN_URL}|+|%]+)`
  );
  const SEARCH_URL_CLASS_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_CLASS}\-([${ALLOWED_CHARACTERS_IN_URL}|+|%]+)`
  );
  const SEARCH_URL_CLASS_GROUP_PATTERN = new RegExp('group-([a-z-]+)');
  const SEARCH_URL_MAKE_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_MAKE}\-([^/]+)`
  );
  const SEARCH_URL_MODEL_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_MODEL}\-([^/]+)`
  );
  const SEARCH_URL_MODELRANGE_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_MODELRANGE}\-([^/]+)`
  );
  const SEARCH_URL_SUBDIVISION_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_SUBDIVISION}\-([${ALLOWED_CHARACTERS_IN_URL}]+)`
  );
  const SEARCH_URL_REGION_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_REGION}\-([a-z|+|%|,|-]+)`
  );
  const SEARCH_URL_COUNTRY_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_COUNTRY}\-([${ALLOWED_CHARACTERS_IN_URL}]+)`
  );
  const SEARCH_URL_CITY_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_CITY}\-([^/]+)`
  );
  const SEARCH_URL_POSTALCODE_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_POSTALCODE}\-([0-9]+)`
  );
  const SEARCH_URL_BY_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_BY}\-([A-Z|a-z|0-9|%-]+)`
  );
  const SEARCH_URL_RADIUS_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_RADIUS}\-([0-9|${config.SEARCH_URL_ITEM_RADIUS_EXACT}|${config.SEARCH_URL_ITEM_RADIUS_ANY}]+)`
  );
  const SEARCH_URL_MAKE_MODEL_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_MAKEMODEL}\-([^/]+)`
  );
  const SEARCH_URL_FUEL_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_FUEL}\-([${ALLOWED_CHARACTERS_IN_URL}|+|%]+)`
  );
  const SEARCH_URL_HULL_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_HULL}\-([${ALLOWED_CHARACTERS_IN_URL}|+|%]+)`
  );
  const SEARCH_URL_ENGINETYPE_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_ENGINE}\-([A-Z|a-z|0-9| |\+|\-]+)`
  );
  const SEARCH_URL_LENGTH_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_LENGTH}\-([0-9]+),?([0-9]+)?`
  );
  const SEARCH_URL_PRICE_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_PRICE}\-([0-9]+),?([0-9]+)?`
  );
  const SEARCH_URL_POWER_HP_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_POWER_HP}\-([0-9]+),?([0-9]+)?`
  );
  const SEARCH_URL_YEAR_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_YEAR}\-([0-9]+)?,?([0-9]+)?`
  );
  const SEARCH_URL_CONDITION_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_CONDITION}\-([^/]+)`
  );
  const SEARCH_URL_KEYWORD_PATTERN = new RegExp(
    `%?3?F?${config.SEARCH_URL_ITEM_KEYWORD}[\-|\=](${KEYWORD_SEARCH_PATTERN}+)`
  );
  const SEARCH_URL_PAGE_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_PAGE}\-([0-9]+)`
  );
  const SEARCH_URL_SORT_PATTERN = new RegExp(
    `${config.SEARCH_URL_ITEM_SORT}\-([^/]+:[^/]+)`
  );
  const SEARCH_URL_MODAL_PATTERN = new RegExp(
    'modal-([a-z|+]+)'
  );
  const BRANDED_SEARCH_URL_OWNER_PATTERN = new RegExp(
    '(([^/]+)-)?([0-9]+)'
  );
  const BLOG_URL_CATEGORY_PATTERN = new RegExp(
    `(${config.BLOG_URL_ENCODED_CATEGORIES})`
  );
  // eslint-disable-next-line no-misleading-character-class
  const BLOG_URL_ARTICLE_PATTERN = new RegExp(
    `([${ALLOWED_CHARACTERS_IN_URL}_$%]+)`
  );

  const SEARCH_TYPES = {
    boats: 'boats',
    engines: 'engines'
  };

  const LOCATION_FILTERS_CONFIG = {
    FR: { country: true, grouping: true,  subdivision: true,  city: true },
    GB: { country: true, grouping: true,  subdivision: true,  city: true  },
    DE: { country: true, grouping: false, subdivision: true,  city: true  },
    US: { country: true, grouping: false, subdivision: true,  city: true  },
    NL: { country: true, grouping: false, subdivision: false, city: true  },
    ES: { country: true, grouping: false, subdivision: false, city: true  },
    HR: { country: true, grouping: false, subdivision: false, city: true  },
    DK: { country: true, grouping: false, subdivision: false, city: true  },
    GR: { country: true, grouping: false, subdivision: false, city: true  },
    IT: { country: true, grouping: false, subdivision: false, city: true  },
    PL: { country: true, grouping: false, subdivision: false, city: true  },
    SE: { country: true, grouping: false, subdivision: false, city: true  },
    TR: { country: true, grouping: false, subdivision: false, city: true  },
  };


  const DEFAULT_REFINE_SEARCH = {
    type: 'any',
    radius: '200',
    make: '',
    price: {},
    year: {},
    makeModel: {},
    condition: 'any',
    region: '',
    subdivision: '',
    country: '',
    city: [],
    postalCode: '',
    forSale: 'all',
    length: {},
    model: '',
    fuelType: [],
    modelRange: '',
    hullMaterial: [],
    engine: '',
    pageSize: '28',
    page: '1',
  };

  const allTypes = ['power-all', 'sail-all', 'unpowered-all'];

  const DEFAULT_MIN_YEAR = 1970;
  const DEFAULT_MAX_YEAR = new Date().getFullYear() + 1;

  const US_COUNTRIES = [
    {
      value: 'US',
      name: 'United States',
    },
  ];

  const FUEL_TYPE_MAPPING = {
    api: {
      gas: 'gasoline'
    },
    urlId: {
      gas: 'gasoline'
    }
  };

  const HULL_MATERIAL_MAPPING = {
    api: {
      composite: 'fiberglass-composite',
      fiberglass: 'fiberglass-reinforced'
    },
    urlId: {
      'fiberglass-composite': 'composite',
      'fiberglass-reinforced': 'fiberglass'
    },
    value: {
      pvc: 'plastic'
    }
  };

  const GROUPS_CLASSES_MAPPING = {
    'pleasure-boats': {
      type: 'power',
      classes:
        'power-aft+power-bay+power-bowrider+power-pcatamaran+power-cruiser+power-cuddy+power-dive+power-downeast+power-skifish+power-runabout+power-walk',
    },
    'fishing-boats': {
      type: 'power',
      classes: 'power-saltfish+power-fresh',
    },
    angler: {
      type: 'power',
      classes: 'power-saltfish',
    },
    'duck-boat': {
      type: 'power',
      classes: 'power-jon',
    },
    weekender: {
      type: 'power',
      classes: 'power-cruiser',
    },
    submersible: {
      type: 'power',
      classes: 'power-submersible',
    },
  };

  const DEFAULT_NO_MAX_LENGTH = '101';
  const DEFAULT_NO_MAX_PRICE = '100000';
  const DEFAULT_NO_MAX_POWER_HP = '500';
  const SLIDER_MAX_VALUE = 'MAX';

  const MAX_MAKE_COUNT = 10;
  const MAX_MODEL_COUNT = 10;
  const MAX_COUNTRIES_COUNT = 10;
  const MAX_SUBDIVISIONS_COUNT = 10;
  const MAX_CITIES_COUNT = 10;

  const INDEXABLE_FACETS = [
    'multiFacetedBoatTypeClass',
    'makeModel',
    'modelRange',
    'subdivision',
    'region',
    'country',
    'city',
    'page',
    'condition',
    'hullMaterial',
    'fuelType'
  ];

  const ENGINES_INDEXABLE_FACETS = [
    'condition',
    'category',
    'country',
    'fuel',
    'makeModel',
    'page'
  ];

  const BRANDED_INDEXABLE_FACETS = [
    'multiFacetedBoatTypeClass',
    'owner',
    'page',
  ];

  const INDEXABLE_PARAMS = [
    'types',
    'classes',
    'make',
    'model',
    'modelRange',
    'country',
    'region',
    'subdivision',
    'city',
    'condition',
    'page',
    'owner',
    'fuel',
    'category',
    'fuelType',
    'hullMaterial'
  ];

  const NON_CANONICAL_PARAMS = ['page', 'owner'];

  const INDEXABLE_TRANSLATION_PARAMS_PRIORITY = [
    'condition',
    'type',
    'class',
    'make',
    'model',
    'modelRange',
    'engineType',
    'sellerType',
    'region',
    'subdivision',
    'country',
    'city',
    'fuelType',
    'hullMaterial'
  ];

  const PAGE_TYPES = {
    boats: 'BOATS',
    engines: 'ENGINES',
    boatDetails: 'BOAT_DETAILS',
    engineDetails: 'ENGINE_DETAILS',
    brandedSearch: 'BRANDED_SEARCH',
    enginesBrandedSearch: 'ENGINES_BRANDED_SEARCH',
    homePage: 'HOMEPAGE',
    healthcheck: 'HEALTHCHECK',
    dealerSearch: 'DEALERSEARCH',
    blog: 'BLOG',
  };

  const IGNORED_SUBDOMAINS = ['qa', 'dev', 'prod'];

  const URL_PATTERNS = [
    {
      type: 'boats',
      pattern: SEARCH_URL_PATTERN,
    },
    {
      type: 'engines',
      pattern: ENGINES_SEARCH_URL_PATTERN,
    },
    {
      type: 'boatDetails',
      pattern: config.BOAT_DETAILS_URL_PATTERN,
    },
    {
      type: 'engineDetails',
      pattern: config.ENGINE_DETAILS_URL_PATTERN,
    },
    {
      type: 'brandedSearch',
      pattern: BRANDED_SEARCH_URL_PATTERN,
    },
    {
      type: 'enginesBrandedSearch',
      pattern: ENGINES_BRANDED_SEARCH_URL_PATTERN,
    },
    {
      type: 'blog',
      pattern: BLOG_URL_PATTERN,
    },
    {
      type: 'homepage',
      pattern: config.HOME_URL_PATTERN,
    },
    {
      type: 'healthcheck',
      pattern: config.HEALTHCHECK_URL_PATTERN,
    },
    {
      type: 'dealerSearch',
      pattern: config.PARTY_SEARCH_URL_ROOT,
    },
  ];

  const getPageTypeFromPath = (path) => {
    return URL_PATTERNS.reduce((match, url) => {
      return (
        match || (matchPath(decodeURIComponent(path), url.pattern) ? PAGE_TYPES[url.type] : null)
      );
    }, null);
  };

  return {
    KEYWORD_SEARCH_PATTERN,
    LISTING_SAME_DEALER,
    LISTING_MULTI_CONTACT,
    LISTING_ENHANCED,
    LISTING_SPONSORED,
    LISTING_PREMIUM_BROKER,
    LISTING_MANUFACTURER,
    LISTING_SUGGESTED,
    LISTING_OEM_BRAND,
    LISTING_STANDARD,
    DEFAULT_NO_BOAT_IMAGE,
    SEARCH_TYPES,
    LOCATION_FILTERS_CONFIG,
    _searchParamsPatterns,
    IGNORED_SUBDOMAINS,
    SEARCH_URL_PATTERN,
    ENGINES_SEARCH_URL_PATTERN,
    BRANDED_SEARCH_URL_PATTERN,
    ENGINES_BRANDED_SEARCH_URL_PATTERN,
    SEARCH_URL_CATEGORY_PATTERN,
    SEARCH_URL_TYPE_PATTERN,
    SEARCH_URL_CLASS_PATTERN,
    SEARCH_URL_CLASS_GROUP_PATTERN,
    SEARCH_URL_MAKE_PATTERN,
    SEARCH_URL_MODEL_PATTERN,
    SEARCH_URL_MODELRANGE_PATTERN,
    SEARCH_URL_SUBDIVISION_PATTERN,
    SEARCH_URL_REGION_PATTERN,
    SEARCH_URL_COUNTRY_PATTERN,
    SEARCH_URL_CITY_PATTERN,
    SEARCH_URL_POSTALCODE_PATTERN,
    SEARCH_URL_BY_PATTERN,
    SEARCH_URL_RADIUS_PATTERN,
    SEARCH_URL_MAKE_MODEL_PATTERN,
    SEARCH_URL_FUEL_PATTERN,
    SEARCH_URL_HULL_PATTERN,
    SEARCH_URL_ENGINETYPE_PATTERN,
    SEARCH_URL_LENGTH_PATTERN,
    SEARCH_URL_PRICE_PATTERN,
    SEARCH_URL_POWER_HP_PATTERN,
    SEARCH_URL_YEAR_PATTERN,
    SEARCH_URL_CONDITION_PATTERN,
    SEARCH_URL_PAGE_PATTERN,
    SEARCH_URL_SORT_PATTERN,
    SEARCH_URL_MODAL_PATTERN,
    BRANDED_SEARCH_URL_OWNER_PATTERN,
    SEARCH_URL_KEYWORD_PATTERN,
    DEFAULT_REFINE_SEARCH,
    BLOG_URL_PATTERN,
    BLOG_URL_CATEGORY_PATTERN,
    BLOG_URL_ARTICLE_PATTERN,
    allTypes,
    DEFAULT_MIN_YEAR,
    DEFAULT_MAX_YEAR,
    US_COUNTRIES,
    FUEL_TYPE_MAPPING,
    HULL_MATERIAL_MAPPING,
    GROUPS_CLASSES_MAPPING,
    DEFAULT_NO_MAX_LENGTH,
    DEFAULT_NO_MAX_PRICE,
    DEFAULT_NO_MAX_POWER_HP,
    SLIDER_MAX_VALUE,
    MAX_MAKE_COUNT,
    MAX_MODEL_COUNT,
    MAX_COUNTRIES_COUNT,
    MAX_SUBDIVISIONS_COUNT,
    MAX_CITIES_COUNT,
    INDEXABLE_FACETS,
    ENGINES_INDEXABLE_FACETS,
    BRANDED_INDEXABLE_FACETS,
    INDEXABLE_PARAMS,
    NON_CANONICAL_PARAMS,
    INDEXABLE_TRANSLATION_PARAMS_PRIORITY,
    PAGE_TYPES,
    URL_PATTERNS,
    getPageTypeFromPath,
    GENERATE_SEARCH_URL_PATTERN,
    GENERATE_ENGINES_SEARCH_URL_PATTERN,
    GENERATE_BRANDED_SEARCH_URL_PATTERN,
    GENERATE_ENGINES_BRANDED_SEARCH_URL_PATTERN,
    ALLOWED_CHARACTERS_IN_URL,
    ALLOWED_CHARACTERS_IN_BLOG_CATEGORY_URL
  };
};
